import { gql } from '@apollo/client'

import { CHECKOUT_SESSION_TYPE_FRAGMENT } from '../fragments/CheckoutSessionTypeFragment'

export const GET_CHECKOUT_SESSION = gql`
  query GetCheckoutSession($input: CheckoutSessionInput!) {
    checkoutSession(input: $input) {
      ...CheckoutSessionType
    }
  }
  ${CHECKOUT_SESSION_TYPE_FRAGMENT}
`
